import Vue from "vue";
import Vuex from "vuex";

import snackbar from "./snackbar";
import user from "./user";
import partner from "./partner";
import business from "./business";
import customer from "./customer"

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    snackbar,
    user,
    partner,
    business,
    customer,
  },
});

export default store;
